const isDev = process.env.NODE_ENV === "development";

export const workflowApiBaseUrl = isDev
  ? "https://workflowsapi.riteliberia.org/api" //"https://localhost:44315/api"
  : "https://workflowsapi.riteliberia.org/api";

export const userApiBaseUrl = isDev
  ? "https://usersapi.riteliberia.org/api" //"https://localhost:44313/api"
  : "https://usersapi.riteliberia.org/api";
